import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder.svg'


const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "house-image-wr"
}
const _hoisted_3 = {
  key: 0,
  class: "slider-wr"
}
const _hoisted_4 = { class: "image-and-dropdown-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "features-wr"
}
const _hoisted_7 = {
  key: 2,
  class: "dropdown-wr"
}
const _hoisted_8 = { class: "container-builderr-logo" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  class: "dropdown-button input-dropdown",
  type: "button"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  class: "dropdown-button input-dropdown",
  type: "button"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "error"
}
const _hoisted_18 = {
  key: 3,
  class: "slider-wr"
}
const _hoisted_19 = { class: "features-and-button-wr" }
const _hoisted_20 = {
  key: 0,
  class: "features-wr"
}
const _hoisted_21 = { class: "floor-plans-wr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Browse Homes for Lot " + _toDisplayString($props.lot.title), 1))
      : _createCommentVNode("", true),
    ($setup.selectedHouseDesign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode($setup["BuilderSliderButtons"], {
                  class: "slider-buttons",
                  items: $setup.props.builders,
                  selectedItem: $setup.selectedBuilder,
                  title: 'Browse: ',
                  contentTitle: 'Builders',
                  isButtonCheckmarkOff: true,
                  onOnSelectItem: $setup.selectBuilder
                }, null, 8, ["items", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            ($setup.selectedHouseDesign)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "house-image",
                  src: $setup.selectedHouseDesign.mainImages[0]
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (!$setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode($setup["HouseFeatures"], {
                    features: $setup.selectedHouseDesign,
                    class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile')
                  }, null, 8, ["features", "class"])
                ]))
              : _createCommentVNode("", true),
            ($setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    ($setup.selectedBuilder)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "builder-logo",
                          src: $setup.selectedBuilder.logo
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", null, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Select Builder", -1)),
                      _createElementVNode("div", null, [
                        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                          control: _withCtx(() => [
                            _createElementVNode("label", _hoisted_11, _toDisplayString($setup.selectedBuilder ? $setup.selectedBuilder.name : "Select a Builder"), 1)
                          ]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.builders, (builder) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: builder._id,
                                  onClick: ($event: any) => ($setup.selectBuilder(builder)),
                                  class: _normalizeClass({ 'dropdown__item-active': builder === $setup.selectedBuilder })
                                }, _toDisplayString(builder.name), 11, _hoisted_12))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (!$setup.selectedBuilder)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Please select a builder"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "Select Design", -1)),
                      _createElementVNode("div", null, [
                        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                          control: _withCtx(() => [
                            _createElementVNode("label", _hoisted_15, _toDisplayString($setup.selectedHouseDesign ? $setup.selectedHouseDesign.name : "Select a Design"), 1)
                          ]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", null, [
                              ($setup.selectedBuilder.houses.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.selectedBuilder.houses, (houseDesign) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: houseDesign._id,
                                      onClick: ($event: any) => ($setup.selectHouseDesign(houseDesign)),
                                      class: _normalizeClass({ 'dropdown__item-active': houseDesign === $setup.selectedHouseDesign })
                                    }, _toDisplayString(houseDesign.name), 11, _hoisted_16))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (!$setup.selectedHouseDesign)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Please select a house design"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!$setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode($setup["BuilderSliderButtons"], {
                    class: "slider-buttons",
                    items: $setup.selectedBuilder.houses,
                    selectedItem: $setup.selectedHouseDesign,
                    title: 'Browse: ',
                    contentTitle: 'Home Designs',
                    isButtonCheckmarkOff: true,
                    onOnSelectItem: $setup.selectHouseDesign
                  }, null, 8, ["items", "selectedItem"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            ($setup.isDesktop && $setup.selectedHouseDesign)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode($setup["HouseFeatures"], {
                    features: $setup.selectedHouseDesign,
                    class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile')
                  }, null, 8, ["features", "class"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "button primary customise",
                onClick: $setup.onRequestQuote
              }, [
                _createTextVNode(_toDisplayString($setup.isDesktop ? "View Floor Plans" : "View floor plans"), 1),
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  class: "icon-arrow",
                  src: _imports_0
                }, null, -1))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}